<template>
<div>
	<header class="ArticleMainHeader">
    <h1 class="ArticleMainTitle">เกี่ยวกับ Image Carousel</h1>
  </header>
  <div class="MarkdownContent hidden-sm-and-down" style="width: 70vw;">
    <v-layout row wrap>
        <v-flex xl3 lg3 md3 style="text-align: center;">
        <div style="text-align: center;">
              <img src="/static/bot component/Imagecarousel/carousel.gif" style="width: 170px;" />
        </div>
    </v-flex>
            <v-flex xl9 lg9 md9 style="text-align: left;">
        <br>
        <br>
        <p class="preindent" style="width: 70%; margin-top: 100px;">Image Carousel เป็นการส่งข้อความแบบรูปภาพ ที่ผู้ใช้งานบอทสามารถกำหนดประเภทของ action ในแต่ละรูปภาพให้เหมาะสมกับการใช้งานได้ เช่น ประเภท Text, Link, Webview , Image และ Postback</p>
    </v-flex>
    </v-layout>
  </div>

    <div class="MarkdownContent hidden-md-and-up">
      <p class="preindent">Image Carousel เป็นการส่งข้อความแบบรูปภาพ ที่ผู้ใช้งานบอทสามารถกำหนดประเภทของ action ในแต่ละรูปภาพให้เหมาะสมกับการใช้งานได้ เช่น ประเภท Text, Link, Webview , Image และ Postback</p>
    </div>

    <div style="text-align: center;" class="hidden-md-and-up">
      <img src="/static/bot component/Imagecarousel/carousel.gif" style="width: 170px;" />
    </div>
  <header class="EndpointHeader">
    <h2 class="EndpointTitle"> API การสร้าง Image Carousel  </h2>
    -
    <span class="EndpointVerbPost"> POST </span>
    <span class="EndpointUrl">
      {{urlbotmsg}}
      <v-icon class="urlcopymessage" style="color:black; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="urlbotmsg">file_copy</v-icon>
    </span>
  </header>

  <div class="MarkdownContent hidden-sm-and-down">
      <h3>Request Header</h3>
      <code class="codecolor">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
      <h3>Request Parameter (JSON)</h3>
    <code class="codecolor">
      <v-tooltip top>
        <v-btn flat icon type="button" style="float: right;" slot="activator" class="requestmessage" v-clipboard:copy="message">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
        <span>Copy to clipboard</span>
      </v-tooltip>
  {
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ba521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"to"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"elements"</span> : [
        {....elementรูปแบบต่าง ๆ....}
    ]
  }
    </code>

    <table id="apimsgtable" style="margin-top: 2vh;">
      <tr>
        <th>คีย์ (Key)</th>
        <th>ประเภท (Type)</th>
        <th>จำเป็น (Required)</th>
        <th>คำอธิบาย (Description)</th>
      </tr>
      <tr>
        <td>bot_id</td>
        <td>String</td>
        <td style="text-align: center;">✅</td>
        <td>รหัสเฉพาะตัวของ Bot</td>
      </tr>
      <tr>
        <td>to</td>
        <td>String</td>
        <td style="text-align: center;">✅</td>
        <td>OneID หรือ UserID ของผู้ใช้ที่ต้องการส่งข้อความไปถึง</td>
      </tr>
      <tr>
        <td>elements</td>
        <td>Array of object</td>
        <td style="text-align: center;">✅</td>
        <td>Array ของข้อมูลแต่ละ Object ที่ต้องการแสดงในข้อความนี้</td>
      </tr>
    </table>
  </div>


  <div class="hidden-md-and-up">
      <h3>Request Header</h3>
      <code class="codecolormo">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
      <h3>Request Parameter (JSON)</h3>
    <code class="codecolormo" style="">
      <v-tooltip top>
        <v-btn flat icon type="button" style="float: right;" slot="activator" class="requestmessage" v-clipboard:copy="message">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
        <span>Copy to clipboard</span>
      </v-tooltip>
  {
    <span class="colorkey">"to"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ba521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"elements"</span> : [
        {....elementรูปแบบต่าง ๆ....}
    ]
  }
    </code>

      <!-- <h3>รายละเอียดข้อมูลที่ใช้ในการส่งไฟล์</h3> -->
      <table id="apimsgtablemo" style="margin-top: 2vh;">
       <tr>
        <th>คีย์ (Key)</th>
        <th>ประเภท (Type)</th>
        <th>จำเป็น (Required)</th>
        <th>คำอธิบาย (Description)</th>
      </tr>
      <tr>
        <td>bot_id</td>
        <td>String</td>
        <td style="text-align: center;">✅</td>
        <td>รหัสเฉพาะตัวของ Bot</td>
      </tr>
      <tr>
        <td>to</td>
        <td>String</td>
        <td style="text-align: center;">✅</td>
        <td>OneID หรือ UserID ของผู้ใช้ที่ต้องการส่งข้อความไปถึง</td>
      </tr>
      <tr>
        <td>elements</td>
        <td>Array of object</td>
        <td style="text-align: center;">✅</td>
        <td>Array ของข้อมูลแต่ละ Object ที่ต้องการแสดงในข้อความนี้</td>
      </tr>

      </table>
    </div>

  <br>
    รูปแบบและประเภทของ element
    <ul v-if="path == '/develop/docs/carouselimage/aboutimagecarousel'">
      <li><a  @click="toPage('/develop/docs/carouselimage/carouselimage_msg')">ประเภทข้อความ</a></li>
      <li><a  @click="toPage('/develop/docs/carouselimage/carouselimage_link')">ประเภทลิงก์</a></li>
      <li><a  @click="toPage('/develop/docs/carouselimage/carouselimage_webview')">ประเภทเว็บวิว</a></li>
      <li><a  @click="toPage('/develop/docs/carouselimage/carouselimage_image')">ประเภทรูปภาพ</a></li>
      <li><a  @click="toPage('/develop/docs/carouselimage/carouselimage_postback')">ประเภทpostback</a></li>
    </ul>
    <ul v-else>
      <li><a  @click="toPage('/docs/carouselimage/carouselimage_msg')">ประเภทข้อความ</a></li>
      <li><a  @click="toPage('/docs/carouselimage/carouselimage_link')">ประเภทลิงก์</a></li>
      <li><a  @click="toPage('/docs/carouselimage/carouselimage_webview')">ประเภทเว็บวิว</a></li>
      <li><a  @click="toPage('/docs/carouselimage/carouselimage_image')">ประเภทรูปภาพ</a></li>
      <li><a  @click="toPage('/docs/carouselimage/carouselimage_postback')">ประเภทpostback</a></li>
  </ul>
<br>

</div>

</template>
<script>
export default {
  data: () => ({
    urlbotmsg: '',
    path: '',
    // urlsendTemplate: '',
    message: '{\n\t"bot_id": "Ba521xx18350a5xxx2bxxxxx",\n\t"to": "U5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t"elements": [\n\t\t{....elementรูปแบบต่าง ๆ....}\n\t]\n}'
  }),
  methods: {
    toPage (page) {
      this.$router.push(page)
    }
  },
  created () {
    this.urlbotmsg = process.env.APIbot_msg + '/api/v1/image-carousel'
    this.path = this.$router.currentRoute.path
    // this.urlsendTemplate = process.env.APIimage + '/api/v1/push_message'
  }
}
</script>

<style type="text/css">
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 100%;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
}
#apimsgtable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apimsgtable td, #apimsgtable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtable tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtable tr:hover {background-color: #ddd;}

#apimsgtable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
.requestmessage {
    display: none !important;
}

.codecolor:hover .requestmessage {
    display: block !important;
}

.urlcopymessage {

    display: none !important;
}
.EndpointUrl:hover .urlcopymessage {
    display: inline !important;
}
.requestmessageresponse{
    display: none !important;
}

.codecolor:hover .requestmessageresponse {
    display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/imagecarouselmessage/aboutimagecarousel.vue